import React from 'react';
import { BecomeSponsor } from './../../elements/SharedElements';
import { Link } from 'gatsby';

const Sponsor = () => (
    <BecomeSponsor>
        <div className="container">
            <h3>Interested In Becoming A Sponsor?</h3>
            <Link className="btn" to="/contact">Contact us</Link>
        </div>
    </BecomeSponsor>
)

export default Sponsor;